import { render } from "./Products.vue?vue&type=template&id=c0e26134"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=c0e26134&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\shop2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__